import { LOADING, LOADINGWHITE } from '../../assets/animated';

interface Props {
  text: string;
  onClick?: () => void;
  type?: 'primary' | 'secondary' | 'p-outlined' | 's-outlined' | 'text';
  disabled?: boolean;
  loading?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  block?: boolean;
  className?: string;
  fontSize?: number;
  id?: string;
  role?: 'submit';
}

export function Button({
  text,
  type = 'primary',
  disabled = false,
  loading = false,
  onClick,
  block,
  size = 'md',
  className,
  fontSize = 14,
  id,
  role
}: Props) {
  const width = block ? 'w-full' : 'w-max';
  const height =
    size === 'xs' ? 'h-8' : size === 'sm' ? 'h-9' : size === 'md' ? 'h-10' : size === 'lg' ? 'h-12' : 'h-10';
  if (type === 'primary') {
    return (
      <button
        type={role}
        id={id}
        disabled={disabled}
        onClick={() => !loading && onClick && onClick()}
        style={{ fontSize: fontSize }}
        className={`${width} ${height} px-4 font-semibold rounded-full text-center bg-secondary text-white border border-secondary cursor-pointer transition-all flex items-center justify-center ${
          disabled ? 'opacity-70' : 'opacity-100'
        } ${className}`}
      >
        {loading ? <img src={LOADINGWHITE} alt="loader" className=" h-6 fill-white text-white" /> : text}
      </button>
    );
  }
  if (type === 'secondary') {
    return (
      <button
        type={role}
        id={id}
        disabled={disabled}
        onClick={() => !loading && onClick && onClick()}
        style={{ fontSize: fontSize }}
        className={`${width} ${height} px-4 font-semibold rounded-full text-center bg-primary text-white border border-primary cursor-pointer transition-all flex items-center justify-center ${
          disabled ? 'opacity-70' : 'opacity-100'
        } ${className}`}
      >
        {loading ? <img src={LOADINGWHITE} alt="loader" className=" h-6 fill-white text-white" /> : text}
      </button>
    );
  }
  if (type === 'p-outlined') {
    return (
      <button
        type={role}
        id={id}
        disabled={disabled}
        onClick={() => !loading && onClick && onClick()}
        style={{ fontSize: fontSize }}
        className={`${width} ${height} ${className} px-4 font-semibold rounded-full text-center bg-transparent border-secondary text-secondary border cursor-pointer transition-all flex items-center justify-center ${
          disabled ? 'opacity-70' : 'opacity-100'
        } `}
      >
        {loading ? <img src={LOADING} alt="loader" className=" h-6 fill-white text-white" /> : text}
      </button>
    );
  }

  if (type === 's-outlined') {
    return (
      <button
        type={role}
        id={id}
        disabled={disabled}
        onClick={() => !loading && onClick && onClick()}
        style={{ fontSize: fontSize }}
        className={`${width} ${height} ${className} px-4 font-semibold rounded-full text-center bg-transparent border-primary text-primary border cursor-pointer transition-all flex items-center justify-center ${
          disabled ? 'opacity-70' : 'opacity-100'
        } `}
      >
        {loading ? <img src={LOADING} alt="loader" className=" h-6 fill-white text-white" /> : text}
      </button>
    );
  }

  return (
    <button
      type={role}
      id={id}
      disabled={disabled}
      onClick={() => !loading && onClick && onClick()}
      style={{ fontSize: fontSize }}
      className={`${block ? 'w-full' : 'w-max text-secondary'} ${
        disabled ? 'opacity-70' : 'opacity-100 flex items-center justify-center'
      } ${className} `}
    >
      {loading ? (
        <img src={LOADING} alt="loader" className=" h-6 fill-white text-white flex items-center justify-center" />
      ) : (
        text
      )}
    </button>
  );
}
